// extracted by mini-css-extract-plugin
export default {"container":"NotFound_container__dvLOl","back":"NotFound_back__OJapD"};